import foldCase from 'fold-case';
import { nfkd } from 'unorm';

export const normalize = (string) => foldCase(nfkd(string));

export const normalizeEmail = (string) => (string.charAt(0).toLowerCase() + string.slice(1)).trim();
